import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { getInitials } from 'helpers';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  CardHeader,
  CardMedia,
  IconButton,
  Avatar, 
  Divider
} from '@material-ui/core';

import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import {AwesomeButtonSocial} from 'react-awesome-button';
import AwesomeButtonStyles from 'react-awesome-button/src/styles/styles.scss';


const useStyles = makeStyles(theme => ({
  root: {},
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1)
  },
  details: {
    display: 'flex'
  }
}));

const UserCard = props => {
  const { className, history, ...rest } = props;

  const classes = useStyles();
  let user = props.user;

  return (
    <CardContent>
      <div className={classes.details}>
        <div>
          <Typography
            gutterBottom
            variant="h3"
          >
            {user.first_name} {user.last_name}, {user.school}
          </Typography>
          <Grid
            container
          >
            <Grid
              item
              md={6}
              xs={6}
            >
              <TextField
                defaultValue={user.major}
                id="standard-read-only-input"
                InputProps={{
                  readOnly: true,
                }}
                label="Major"
                margin="dense"
                style={{marginRight: 10}}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <TextField
                defaultValue={user.minor}
                id="standard-read-only-input"
                InputProps={{
                  readOnly: true,
                }}
                label="Minor"
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid
            container
          >
            <Grid
              item
              md={6}
              xs={6}
            >
              <TextField
                defaultValue={user.email}
                id="standard-read-only-input"
                InputProps={{
                  readOnly: true,
                }}
                label="Email"
                margin="dense"
                style={{marginRight: 10,  marginBottom: '1rem'}}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <TextField
                defaultValue={user.phone_number}
                id="standard-read-only-input"
                InputProps={{
                  readOnly: true,
                }}
                label="Phone"
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Divider variant="middle"
                   style={{marginBottom: '1rem'}}/>
          <Grid
            container
            spacing={24}
            style={{alignItems: 'center', justify: 'center', justifyContent: 'center', justifyItems: 'center'}}
          >
            <Grid
              item
              md={6}
              xs={6}

            >
              {
                (user.linkedin_username && user.linkedin_username!=='')?
                  <AwesomeButtonSocial
                    cssModule={AwesomeButtonStyles}
                    type="linkedin"
                    style={{width: '95%'}}
                    href={"https://www.linkedin.com/in/" + user.linkedin_username}
                    target="_blank"
                  >
                  </AwesomeButtonSocial>
                  :<div />
              }
            </Grid>

            <Grid
              item
              md={6}
              xs={6}
            >

              {
                (user.github_username && user.github_username!=='')?
                  <AwesomeButtonSocial
                    cssModule={AwesomeButtonStyles}
                    type="github"
                    style={{width: '100%'}}
                    href={"https://www.github.com/" + user.github_username}
                    target="_blank"
                  >
                  </AwesomeButtonSocial>
                  :<div />

              }
            </Grid>

          </Grid>
          {
            (user.cv_url && user.cv_url!=='')?
              <Button variant="contained" color="primary" onClick={()=>{ window.open(user.cv_url, '_blank');}} style={{marginTop: 20, width: '100%'}}>
                Download CV
              </Button>
              :<div />
          }
        </div>
        <Avatar
          className={classes.avatar}
          src={user.profile_picture}
          style={{width:150, height: 150, marginLeft: 50}}
        />

      </div>
      {/* <div className={classes.progress}>
          <Typography variant="body1">Profile Completeness: 70%</Typography>
          <LinearProgress
            value={70}
            variant="determinate"
          />
        </div> */}
    </CardContent>
  );
};

UserCard.propTypes = {
  className: PropTypes.string,
  users: PropTypes.object.isRequired
};

export default withRouter(UserCard);
